module.exports = __webpack_public_path__ + "static/media/icon-chevron-left-custom.db3705e0.png";